module.exports = __webpack_public_path__ + "img/38-800x800.21435172.jpg";